module.exports = __webpack_public_path__ + "media/images/mailer/icon_cached-26ffa26120a2a16a9be78a75cc603793.png";